import { Component, inject } from '@angular/core';
import { StorageUploadStateService } from '../../services/storage-upload-state.service';
import { FileUploadState } from '../../models/file-upload-state.model';
import { NgClass, NgStyle } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'dnv-file-upload',
  templateUrl: './file-upload.component.html',
  imports: [
    NgStyle,
    MatIcon,
    NgClass,
    TranslatePipe,
  ],
})
export class FileUploadComponent {
  public readonly storageUploadStateService = inject(StorageUploadStateService);
  public readonly FileUploadState = FileUploadState;

}
